import { useQuery } from '@tanstack/react-query';

import { brokers, type BrokerConsultationStatus } from '@/shared/api/resources';

/** Chave do limite de consultas, sob a do corretor: invalidar o corretor a refaz. */
export function chaveDoLimiteDeConsultas(brokerId: string) {
  return ['broker', brokerId, 'consultation-limit'] as const;
}

/**
 * Limite de consultas de bureau e a situacao do periodo (ListarParametrosLimiteConsulta
 * e ObterBloqueioConsulta do OnPoint), lidos ao abrir o cadastro do corretor (P-COR-3).
 */
export function useLimiteDeConsultas(brokerId: string) {
  return useQuery({
    queryKey: chaveDoLimiteDeConsultas(brokerId),
    queryFn: ({ signal }) => brokers.consultationLimit(brokerId, signal),
    enabled: brokerId !== '',
  });
}

/** O que o limite acrescenta ao aviso "Atencao!" ao abrir o corretor (COR-032). */
export function avisosDoLimite(
  situacao: BrokerConsultationStatus | undefined,
): string[] {
  if (!situacao?.configured || !situacao.limit) return [];
  const limite = situacao.limit.max_queries;
  if (situacao.blocked) {
    return [
      `Consultas a bureau bloqueadas: limite de ${limite} consulta(s) atingido no periodo (${situacao.used} feitas). Consulta nova e recusada ate o desbloqueio ou o fim do periodo.`,
    ];
  }
  if (situacao.reached) {
    return [
      `Limite de consultas a bureau atingido no periodo: ${situacao.used} de ${limite}.`,
    ];
  }
  return [];
}
